import React from "react";
import { Link } from "react-router-dom";
import { START_HERE_STEPS } from "../data/content";
import { ArrowRight, CheckCircle } from "@phosphor-icons/react";

export default function StartHere() {
  return (
    <main className="max-w-5xl mx-auto px-6 md:px-10 py-16 md:py-24">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#0033A0]">Beginner guide</p>
      <h1 className="font-display text-4xl md:text-6xl font-black tracking-tighter text-slate-900 mt-3 leading-[1.05]">
        Start Here.
      </h1>
      <p className="text-lg text-slate-700 mt-5 max-w-2xl leading-relaxed">
        Six steps to go from {`"curious"`} to {`"confident."`} No sales talk, no pressure — just the order most people wish they{`'`}d known about.
      </p>

      <ol className="mt-14 space-y-6">
        {START_HERE_STEPS.map((s, i) => (
          <li
            key={s.n}
            data-testid={`step-${s.n}`}
            className="grid grid-cols-[auto,1fr] gap-5 items-start bg-white border border-slate-200 rounded-xl p-6 md:p-8 fade-up"
            style={{ animationDelay: `${i * 80}ms` }}
          >
            <span className="h-12 w-12 rounded-full bg-[#0033A0] text-white font-display font-black text-lg flex items-center justify-center">
              {s.n}
            </span>
            <div>
              <h2 className="font-display text-xl md:text-2xl font-bold text-slate-900 leading-tight">{s.title}</h2>
              <p className="text-slate-700 mt-2 leading-relaxed">{s.body}</p>
            </div>
          </li>
        ))}
      </ol>

      <div className="mt-16 bg-slate-50 border border-slate-200 rounded-xl p-8">
        <div className="flex items-start gap-4">
          <CheckCircle size={28} weight="fill" className="text-emerald-600 shrink-0 mt-1" />
          <div>
            <h3 className="font-display font-bold text-xl text-slate-900">Ready for the next step?</h3>
            <p className="text-slate-700 mt-1 leading-relaxed">
              Compare the branches side-by-side, or dive into the benefit topics.
            </p>
            <div className="mt-4 flex flex-wrap gap-3">
              <Link to="/compare" data-testid="start-here-compare-link" className="inline-flex items-center gap-2 bg-[#0033A0] hover:bg-[#002277] text-white font-semibold py-3 px-6 rounded-md transition-colors">
                Compare Branches <ArrowRight size={16} weight="bold" />
              </Link>
              <Link to="/topics" data-testid="start-here-topics-link" className="inline-flex items-center gap-2 bg-white hover:bg-slate-100 border border-slate-300 text-slate-900 font-semibold py-3 px-6 rounded-md transition-colors">
                Browse All Topics
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
